import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import useIsFirstRender from '../../../../../hooks/useIsFirstRender';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../modules/translation/TranslationContext';

interface EmptyListProps {
  isLoading: boolean;
  hasData: boolean;
  query?: string;
}

const EmptyList = ({ isLoading, hasData, query }: EmptyListProps) => {
  const { translate } = useTranslation();
  const isFirstRender = useIsFirstRender();

  if (isFirstRender || hasData || isLoading) {
    return null;
  }

  const emptyMessage = query
    ? LangEnum.GLOBAL_SEARCH_EMPTY_RESULTS
    : LangEnum.GLOBAL_EMPTY_OPTIONS_LIST;

  return (
    <Box
      sx={{
        padding: 2,
        textAlign: 'center',
      }}
    >
      <Typography gutterBottom color="textSecondary">
        {translate(emptyMessage)}
      </Typography>
    </Box>
  );
};

export default EmptyList;
